// enums
import { ID_TYPE } from '../../enums/user/id-types';
import { usersType } from '../../enums/user/user-type';

export const listOfIdType = [
    { name: 'مواطن', id: ID_TYPE.citizen, status: [usersType.normalUser] },
    { name: 'مقيم', id: ID_TYPE.guest, status: [usersType.normalUser ]},
    { name: 'منشاة', id: ID_TYPE.office, status: [usersType.office, usersType.superVisor] }
]